import { endPoint } from "./base.config"

export const companyBank = {
  fetchAllCompanyBankInfoByCompanyId: `${endPoint}company-banks/fetch-all-company-bank-info-by-company-id`,
  getSettingBankAccount: `${endPoint}company-banks/get-setting-bank-accounts`,
  setDefaultAccountNumber: `${endPoint}company-banks/set-default-account-number`,
  getDefaultAccountNumber: `${endPoint}company-banks/get-default-bank`,
  deleteCompanyBank: `${endPoint}company-banks/:id`,
  sortingBankAccount: `${endPoint}company-banks/sorting-setting-bank-accounts`,
  getServiceDates: `${endPoint}v2/company-banks/:id/service-dates`,
}

export const companyBankV2 = {
  getBankVerifyPayment: `${endPoint}v2/company-banks/:companyId/banks-verified-payment`,
  getBankBalances: `${endPoint}v2/company-banks/:companyId/balances`,
  getSettingBanks: `${endPoint}v2/company-banks/:companyId/setting-banks`,
  add: `${endPoint}v2/company-banks`,
  update: `${endPoint}v2/company-banks/:id`,
} 